import {Link, navigate} from "gatsby";
import React from 'react'
import styled from 'styled-components'

import linkedin from "../../../static/images/header/Linkedin-blue.svg";
import linkedinHover from "../../../static/images/header/Linkedin-hover.svg";
import twitter from "../../../static/images/header/Twitter-blue.svg";
import twitterHover from "../../../static/images/header/Twitter-hover.svg";

const Footer = ({path}) => {
    return (
        <FooterWrapper>
            <FooterLinks>
                <Left>
                    <List>
                        {path !== '/who-we-are/' ?
                            <Link to={'/who-we-are/'}>
                                <ListItem><span>Who we are</span></ListItem>
                            </Link> :
                            <ListItem><span>Who we are</span></ListItem>
                        }
                        {path !== '/sectors/' ?
                            <Link to={'/sectors/'}>
                                <ListItem><span>Where we focus</span></ListItem>
                            </Link> :
                            <ListItem><span>Where we focus</span></ListItem>
                        }
                        {path !== '/what-we-build/' ?
                            <Link to={'/what-we-build/'}>
                                <ListItem><span>What we build</span></ListItem>
                            </Link> :
                            <ListItem><span>What we build</span></ListItem>
                        }
                        {path !== '/contact-us/' ?
                            <Link to={'/contact-us/'}>
                                <ListItem><span>How to connect</span></ListItem>
                            </Link> :
                            <ListItem><span>How to connect</span></ListItem>
                        }
                    </List>
                </Left>
                <Right>
                    <ul className={'main-nav-list'}>
                        <li>
                            <a href={'https://www.linkedin.com/company/medad-technology'} target={'_blank'}>
                                <Linkedin/>
                            </a>
                        </li>
                        <li>
                            <a href={'https://twitter.com/MedadTech'} target={'_blank'}>
                                <Twitter/>
                            </a>
                        </li>
                    </ul>
                </Right>
            </FooterLinks>
            <SubtleLinks>
                <Copyright>Medad Holding © All rights reserved 2022</Copyright>
                <Links>
                    <Link to={'/terms-of-use/'}><Policy>Terms of use</Policy></Link>
                    <Link to={'/privacy-policy/'}><Policy className={'second'}>Privacy Policy</Policy></Link>
                </Links>
            </SubtleLinks>

            <RightMobile>
                <ul className={'main-nav-list'}>
                    <li>
                        <a href={'https://www.linkedin.com/company/medad-technology'} target={'_blank'}>
                            <Linkedin/>
                        </a>
                    </li>
                    <li>
                        <a href={'https://twitter.com/MedadTech'} target={'_blank'}>
                            <Twitter/>
                        </a>
                    </li>
                </ul>
            </RightMobile>
            <SubtleLinksMobile>
                <Links>
                    <Link to={'/terms-of-use/'}><Policy className={'first'}>Terms of use</Policy></Link>
                    <Link to={'/privacy-policy/'}><Policy className={'second'}>Privacy Policy</Policy></Link>
                </Links>
            </SubtleLinksMobile>
            <CopyrightMobile>
                <Copyright>Medad Holding ©<br/> All rights reserved 2022</Copyright>
            </CopyrightMobile>
        </FooterWrapper>
    )
}

export default Footer

const SubtleLinksMobile = styled.div`
  display: none;
  @media ${({theme}) => theme.breakpoints.mobile} {
    display: block;
    margin-top: 4rem;
  }
`

const CopyrightMobile = styled.div`
    display: none;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    display: block;
  }
`

const RightMobile = styled.div`
  display: none;
  @media ${({theme}) => theme.breakpoints.mobile} {
    display: block;
  }

  align-self: flex-start;
  margin-top: 2rem;

  .main-nav-list {
    list-style: none;
    display: flex;
    flex-direction: row;
    align-items: center;

    li {
      margin-left: 0rem;
      margin-right: 3.0rem;
    }
  }

  @keyframes fadein {
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
  @-moz-keyframes fadein { /* Firefox */
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
  @-webkit-keyframes fadein { /* Safari and Chrome */
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
  @-o-keyframes fadein { /* Opera */
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
`

const Links = styled.div`
  margin-left: 7.7rem;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  .second {
    margin-left: 3.6rem;
  }

  @media ${({theme}) => theme.breakpoints.mobile} {
    margin: 0;
    justify-content: flex-start;
    align-items: center;
    .first {
      margin-left: 0;
    }
  }
`

const Policy = styled.p`
  color: ${({theme}) => theme.colors.primary};
  font-family: Sequel55;
  font-size: 1.2rem;
  line-height: 1.6rem;
  opacity: .49;
  -webkit-tap-highlight-color: transparent;
`

const SubtleLinks = styled.div`
  display: flex;
  @media ${({theme}) => theme.breakpoints.mobile} {
    display: none;
  }
`

const FooterLinks = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  @media ${({theme}) => theme.breakpoints.mobile} {
    flex-direction: column;
  }
`

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 0.1rem solid #B8B8B8;
  margin: 0rem 12rem;
  background-color: ${({theme}) => theme.colors.white};
  padding: 4rem 0rem;
  @media ${({theme}) => theme.breakpoints.mobile} {
    margin: 0rem 2.4rem 0rem 2.4rem;
  }
`

const Left = styled.div`
`

const Right = styled.div`
  align-self: flex-start;
  padding-top: 1.5rem;

  @media ${({theme}) => theme.breakpoints.mobile} {
    display: none;
  }

  .main-nav-list {
    list-style: none;
    display: flex;
    flex-direction: row;
    align-items: center;

    li {
      margin-left: 4.0rem;
      @media ${({theme}) => theme.breakpoints.mobile} {
        margin-left: 0rem;
        margin-right: 3.0rem;
        margin-top: 8.0rem
      }
    }
  }

  @keyframes fadein {
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
  @-moz-keyframes fadein { /* Firefox */
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
  @-webkit-keyframes fadein { /* Safari and Chrome */
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
  @-o-keyframes fadein { /* Opera */
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
`

const List = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 8.0rem;
  @media ${({theme}) => theme.breakpoints.mobile} {
    display: flex;
    flex-direction: column;
  }
`

const Copyright = styled.p`
  padding: 5.5rem 0 0 0;
  opacity: 0.49;
  font-size: 1.2rem;
  line-height: 1.6rem;
  font-family: ${({theme}) => theme.fonts.sequel55};

  br {
    display: none;
  }

  @media ${({theme}) => theme.breakpoints.mobile} {
    padding-top: 4rem;
    br {
      display: inline;
    }
  }
`

const ListItem = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 2.0rem;
  line-height: 2.8rem;
  padding: 1.5rem 0;
  position: relative;
  width: fit-content;
  span {
    -webkit-tap-highlight-color: transparent;
  }

  span:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 3px;
    bottom: 0;
    left: 0;
    background: ${({theme}) => theme.colors.secondary};;
    visibility: hidden;
    transform: scaleX(0);
    transition: .25s linear;
  }

  span:hover:before,
  span:focus:before {
    visibility: visible;
    transform: scaleX(1);
  }

  @media ${({theme}) => theme.breakpoints.mobile} {
    font-size: 1.6rem;
    line-height: 2.2rem;
  }
`

const Linkedin = styled.div`
  width: 23px;
  height: 23px;
  background-image: url(${linkedin});
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;

  &:hover {
    background-image: url(${linkedinHover});
    animation: fadein 0.6s;
    -moz-animation: fadein 0.6s; /* Firefox */
    -webkit-animation: fadein 0.6s; /* Safari and Chrome */
    -o-animation: fadein 0.6s; /* Opera */
  }
`

const Twitter = styled.div`
  width: 25px;
  height: 23px;
  background-image: url(${twitter});
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;

  &:hover {
    animation: fadein 0.6s;
    -moz-animation: fadein 0.6s; /* Firefox */
    -webkit-animation: fadein 0.6s; /* Safari and Chrome */
    -o-animation: fadein 0.6s; /* Opera */
    background-image: url(${twitterHover});
  }
`
